import React, {PureComponent} from 'react';
import { connect } from 'dva';
import Dimio, {DimioNotice} from 'dimio';
import PurchaseForm from './PurchaseForm';
import {StripeProvider, Elements } from 'react-stripe-elements';
import config from '../config/config';
import "../style/purchase.scss"

const {api} = config.purchase;

class PurchasePage extends PureComponent {
  componentWillMount() {
    const {core:{defaultValues}} = this.props;

    if(!defaultValues.stripeApi){
      console.error("API key is not set");
//      this.showError("API key is not set");
    }

  }

  render() {
    const { core } = this.props;
    const { defaultValues } = core;

    return (
      <section id="purchase-page" className="page">
        <DimioNotice {...core} />

        <div className="">
          <StripeProvider apiKey={defaultValues.stripeApi}>
            <Elements locale="ja">
              <PurchaseForm {...this.props} />
            </Elements>
          </StripeProvider>
        </div>
      </section>
    );
  }
}

export default connect(({ core, purchase }) => ({
  core, purchase,
}))(PurchasePage);



// WEBPACK FOOTER //
// ./src/pages/purchase/components/PurchasePage.js